import { RadioGroupField } from 'components/form'
import { useMemo } from 'react'
import { MetaPath } from 'util/metaPath/metaPath'

import { TipoDoseEnum } from '../../model-prescricao'
import { RENOVACAO_TOOLTIP_TEXT } from '../utils/constants-prescricao'

interface TipoDoseRadioFieldProps {
  name: MetaPath<string>
  isRenovacao: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const TIPO_DOSE_OPTIONS = [
  { value: TipoDoseEnum.COMUM, label: 'Comum' },
  { value: TipoDoseEnum.UNICA, label: 'Única' },
  { value: TipoDoseEnum.FRACIONADA, label: 'Fracionada' },
]

export const TipoDoseRadioField = ({ name, isRenovacao, onChange }: TipoDoseRadioFieldProps) => {
  const options = useMemo(() => {
    return TIPO_DOSE_OPTIONS.map((option) => {
      const isDoseUnicaDisabled = isRenovacao && option.value === TipoDoseEnum.UNICA

      return {
        ...option,
        disabled: isDoseUnicaDisabled,
        tooltipText: isDoseUnicaDisabled ? RENOVACAO_TOOLTIP_TEXT : undefined,
      }
    })
  }, [isRenovacao])
  return <RadioGroupField label='Tipo de dose' required name={name} options={options} onChange={onChange} />
}
